import * as z from "zod/v4";

const ChannelSchema_ = z.enum(["REDO", "EBAY", "POSHMARK"]);
export const ChannelSchema = ChannelSchema_;
export type Channel = z.infer<typeof ChannelSchema_>;

export const ChannelEnum = ChannelSchema_.enum;
